__turbopack_context__.v({
  "add-coupon-button": "redeem-coupon-module-scss-module__0GzZ8q__add-coupon-button",
  "applied-text": "redeem-coupon-module-scss-module__0GzZ8q__applied-text",
  "clear-button": "redeem-coupon-module-scss-module__0GzZ8q__clear-button",
  "code": "redeem-coupon-module-scss-module__0GzZ8q__code",
  "code-icon-button": "redeem-coupon-module-scss-module__0GzZ8q__code-icon-button",
  "code-in-checkout-pane": "redeem-coupon-module-scss-module__0GzZ8q__code-in-checkout-pane",
  "code-text": "redeem-coupon-module-scss-module__0GzZ8q__code-text",
  "codes": "redeem-coupon-module-scss-module__0GzZ8q__codes",
  "container": "redeem-coupon-module-scss-module__0GzZ8q__container",
  "input-mode": "redeem-coupon-module-scss-module__0GzZ8q__input-mode",
  "text-input-applied-coupon": "redeem-coupon-module-scss-module__0GzZ8q__text-input-applied-coupon",
  "title": "redeem-coupon-module-scss-module__0GzZ8q__title",
});
